import type { FAQItem } from '../../seo/FAQSchema';

export const wmsIntegrationFaqs: FAQItem[] = [
  {
    question: 'Which platforms do you integrate with?',
    answer:
      'Shopify, Amazon Seller Central, TikTok Shop, eBay and custom APIs. Mintsoft native connectors and webhooks keep multi-channel orders flowing without manual CSV uploads.',
  },
  {
    question: 'Do I get live portal access?',
    answer:
      'Yes. Your secure client portal shows real-time stock locations, open orders, inbound schedules, returns status and fulfilment performance metrics — available 24/7 from any device.',
  },
  {
    question: 'How fast is order sync?',
    answer:
      'Orders typically import within minutes. Inventory updates as stock is received, picked, packed or dispatched, so channels stay aligned and oversell risk drops.',
  },
  {
    question: 'What about custom requirements?',
    answer:
      'Full API flexibility. We build EDI for wholesalers, bundle sync for subscription services, ERP connections, webhooks and live TikTok order batching when native connectors are not enough.',
  },
];
